import reduceReducers from 'reduce-reducers';

//Siblings reducers
import addressBookReducer from './address-book-reducer';

export default reduceReducers(addressBookReducer);
